import React from "react";

const Footer = () => {
	return (
		<footer className="container bg-white border-top py-3">
			<div className="d-flex justify-content-between align-items-center">
				{/* Left side */}
				<small className="text-muted">
					© {new Date().getFullYear()}. All Rights Reserved
				</small>

				{/* Right side */}
				<small className="text-muted">
					Version 1.2.0
				</small>
			</div>
		</footer>
	);
};

export default Footer;
